import { createContext, useContext } from "react";
import type { Session } from "@supabase/supabase-js";

export interface Site {
  id: string;
  name: string;
  client_type: string | null;
}

export interface Org {
  id: string;
  name: string;
  logo_path: string | null;
  scenarios_per_week: number;
}

export interface AdminContextValue {
  session: Session;
  admin: { name: string; can_approve: boolean };
  org: Org;
  sites: Site[];
  /** Reads the company and its sites again, after Settings changes them. */
  reload: () => Promise<void>;
}

export const AdminContext = createContext<AdminContextValue | null>(null);

export function useAdmin(): AdminContextValue {
  const value = useContext(AdminContext);
  if (!value) throw new Error("useAdmin outside the signed-in app");
  return value;
}
